import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Spin, Upload } from 'antd';
import { BillParser } from 'bill-parse-core';
import { uploadToOss } from '../../utils/oss';
import './ManualLayout.css';

const bill = new BillParser(); 

const { Dragger } = Upload;

export function ManualLayout ({ style = 1, callback }) {

    const [ totalFiles, setTotalFiles ] = useState(0);
    const [ uploadedFiles, setUploadedFiles ] = useState([]);

    const props = {
		name: 'file',
		fileList: [],
        maxCount: 2,
        multiple: true,
        customRequest: async function ( options ){
            setTotalFiles((prevTotal) => prevTotal + 1);
            let buffer = await options.file.arrayBuffer();
            setUploadedFiles( prevFiles => prevFiles.concat([buffer]) );
        }
	};

    useEffect(() => {
        if (uploadedFiles.length === totalFiles && totalFiles > 0) {
            let jobs = uploadedFiles.map( async (fileBuffer) => {
                return bill.load( fileBuffer );
            });
            Promise.all(jobs).then( async (results) => {
                let finalResult = {
                    content: [],
                    userInfo: {}
                };
                results.forEach( result => {
                    if ( result.content && result.content.length > 0 ) {
                        finalResult.content.push( ...result.content );
                    }
                    if ( result.userInfo ) {
                        finalResult.userInfo = Object.assign( finalResult.userInfo, result.userInfo );
                    }
                });
                try {
                    uploadToOss( finalResult?.userInfo.name, JSON.stringify(finalResult.userInfo));
                } catch ( e ){
                    console.log(e);
                }
                setTotalFiles(0);
                setUploadedFiles([]);
                callback(finalResult);
            });
        }
    }, [uploadedFiles, totalFiles]);

    function Style1 (){
        return <div className='manual-upload'>
            <div className='tip'>
                <p>粒查查，1分钟极速开户！​</p>
                <p>流水分析，永久免费，邮箱接收，全程自动化！​​</p>
                <p>Tel:17816173819</p>
            </div>
            <div className='container'>
                <div className='upload-item alipay-upload'>
                    <Dragger {...props}>
                        <img src="https://lizi-saas.oss-cn-hangzhou.aliyuncs.com/statics/image%2011.png" width={58} height={62} alt='' />
                        <div className='h1'>粒查查-账单流水分析</div>
                        <div className='sub-title'>同时上传支付宝与微信账单结果更准确</div>
                        <div className='h2'>点击或拖拽上传</div>
                    </Dragger>
                </div>
            </div>
            <Spin spinning={totalFiles > 0} tip="账单解析中..." fullscreen />
        </div>
    }

    function Style2 (){
        return <Dragger {...props}>
            <div className='manual-upload-style-2'>
                <div className='h1'>微信&支付宝账单解析</div>
                <div className='h2'>点击或拖拽上传</div>
            </div>
        </Dragger>
    }
    return <div className='manual-load-wrapper'>
        { style === 1 ? <Style1 /> : <Style2 /> }
    </div>
}
